import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import MainLayout from "@/components/layout/MainLayout";
import { isLoggedInAtom } from "@/store/atoms/authAtoms";
import { getUserDetailOptions } from "@/features/users/users.queries";

export const Route = createFileRoute("/_layout")({
  beforeLoad: async ({ context, location }) => {
    const { store, queryClient } = context;

    // Check Session
    const loggedIn = store.get(isLoggedInAtom);
    if (!loggedIn) {
      throw redirect({
        to: "/login",
        search: {
          redirect: location.href,
        },
      });
    }
    try {
      await queryClient.ensureQueryData(
        getUserDetailOptions({ staleTime: 5000 }),
      );
    } catch (error) {
      throw redirect({
        to: "/login",
      });
    }
  },
  component: ProtectedLayoutRoute,
});

function ProtectedLayoutRoute() {
  return <MainLayout children={<Outlet />} />;
}
